"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function () {}; return { s: F, n: function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (e) { throw e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function () { it = it.call(o); }, n: function () { var step = it.next(); normalCompletion = step.done; return step; }, e: function (e) { didErr = true; err = e; }, f: function () { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        let key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: () => from[key],
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: true
}), mod);
var error_response_exports = {};
__export(error_response_exports, {
  ErrorResponseErrorEnum: () => ErrorResponseErrorEnum
});
module.exports = __toCommonJS(error_response_exports);
const ErrorResponseErrorEnum = {
  BadRequest: "Bad Request",
  FileExpired: "File Expired",
  Forbidden: "Forbidden",
  ResourceLocked: "Resource Locked",
  FormatNotSupported: "Format Not Supported",
  InsufficientCredit: "Insufficient Credit",
  InternalServerError: "Internal Server Error",
  JobError: "Job error",
  JobExpired: "Job Expired",
  JobInProgress: "Job In Progress",
  JobIsNotOfTypeAlignment: "Job is not of type alignment",
  JobIsNotOfTypeTranscription: "Job is not of type transcription",
  JobNotFound: "Job not found",
  JobRejected: "Job rejected",
  JobRejectedDueToInvalidAudio: "Job rejected due to invalid audio",
  JobRejectedDueToInvalidText: "Job rejected due to invalid text",
  MalformedRequest: "Malformed request",
  MissingCallback: "Missing callback",
  MissingDataFile: "Missing data_file",
  MissingTextFile: "Missing text_file",
  NoLanguageSelected: "No language selected",
  NotImplemented: "Not Implemented",
  PermissionDenied: "Permission Denied",
  RequestedProductNotAvailable: "Requested product not available",
  TranscriptionNotReady: "Transcription not ready",
  LatticeNotGenerated: "Lattice not generated",
  LogFileNotAvailable: "Log file not available",
  RequestedEarlyAccessReleaseNotAvailable: "Requested Early Access Release not available",
  UnprocessableEntity: "Unprocessable Entity"
};